/* eslint-disable no-lonely-if */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import * as XLSX from 'xlsx';
import { toast } from 'react-toastify';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { SERVER_BASE_URL } from '../../redux/apiConstants';
import { getCookies } from '../../hooks/useCookies';
import { CapitalizeFirstLetter, DateFormatter } from '../../utilityFunctions/utilsFunctions';

function ExportToExcel({ apiUrl, fileName }) {
  const [loading, setLoading] = useState(false);
  const token = `Bearer ${getCookies('Token')}`;
  const exportToCSV = (appendUrl, filename) => () => {
    setLoading(true);
    const url = `${SERVER_BASE_URL}/${appendUrl}`;
    fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
    })
      .then((resp) => resp.json())
      .then((resp) => {
        if (resp.context === 'get-event' && resp.code === 200) {
          const cleanArray = resp.data.event.map((item) => {
            const { userName, ticketId, seatsBooked, paymentStatus } = item;
            return {
              Attendees: userName,
              Email: ticketId?.email,
              'Contact Number': ticketId?.phone,
              'Number Of Tickets': seatsBooked,
              Seats: ticketId?.seatsBooked,
              'Total Payment': `$${ticketId?.totalAmount}`,
              'Transaction Id': ticketId?.transactionId,
              'Booking Date And Timw': `${DateFormatter(
                ticketId?.bookedDate,
                'toEventViewDate'
              )}, ${DateFormatter(ticketId?.bookedDate, 'toTime')}`,
              'Payment Method': CapitalizeFirstLetter(ticketId?.paymentMethod),
              'Ticket Status': CapitalizeFirstLetter(paymentStatus),
            };
          });
          const ws = XLSX.utils.json_to_sheet(cleanArray);
          const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
          XLSX.writeFile(wb, `${filename}-${resp.data.show.eventName}.xlsx`);
          setLoading(false);
        } else {
          if (resp.code === 400) {
            toast.error("'Currently there is no active event.");
            setLoading(false);
          } else {
            // eslint-disable-next-line no-underscore-dangle
            const cleanArray = resp.data.result.results.map((item) => {
              const { name, businessName, email, phone, wallet, active } = item;
              return {
                Vendor_Name: name,
                Stall_Name: businessName,
                Email: email,
                Contact_Number: phone,
                Tokens_Received: wallet?.tokensLeft,
                Status: active ? 'Active' : 'Inactive',
              };
            });
            const ws = XLSX.utils.json_to_sheet(cleanArray);
            const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
            XLSX.writeFile(wb, `${filename}.xlsx`);
            setLoading(false);
          }
        }
      })
      .catch((e) => {
        toast.error('Currently there is no active event.');
        setLoading(false);
      }); // setting response to state posts
  };
  return (
    // <li>
    //   <a className="dropdown-item" onClick={exportToCSV(apiUrl, fileName)}>
    //     Export Excel
    //   </a>
    // </li>
    <button className="addBtnyellow mb-20" type="button" onClick={exportToCSV(apiUrl, fileName)}>
      {' '}
      <FontAwesomeIcon icon={faDownload} className="add_icon" />
      {loading ? 'Please Wait...' : 'Download'}
    </button>
  );
}

ExportToExcel.propTypes = {
  apiUrl: PropTypes.string.isRequired,
  fileName: PropTypes.string.isRequired,
};

export default ExportToExcel;
